<template>
  <div id="contenedor-deducciones-default">
    <v-container fluid>
      <v-card class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevaDeduccion="registrarNuevaDeduccion">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado :listadoDeducciones="getDeducciones"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaDeduccion"
      :width="!$vuetify.breakpoint.xs ? '50%' : '90%'">
      <registrar-nueva-deduccion
        v-if="mostrarVentanaRegistrarNuevaDeduccion"
        v-on:cerrar="cerrarRegistrarNuevaDeduccion" />
    </v-dialog>
    <v-dialog
      v-if="estaDeduccion"
      v-model="mostrarVentanaEditarDeduccion"
      :width="!$vuetify.breakpoint.xs ? '50%' : '90%'">
      <editar-deduccion
        :deduccionEditar="estaDeduccion"
        v-on:cerrar="cerrarEditarDeduccion">
      </editar-deduccion>
    </v-dialog>
    <v-dialog
      v-if="estaDeduccion"
      v-model="mostrarVentanaEliminarDeduccion"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-deduccion
        :deduccionEliminar="estaDeduccion"
        v-on:cerrar="cerrarRemoverDeduccion">
      </eliminar-deduccion>
    </v-dialog>
  </div>
</template>

<script>
import DEDUCCIONES from '@/graphql/querys/administracion/catalogos/deducciones/deducciones.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevaDeduccion from '@/components/administracion/configuracion/catalogos/deducciones/Nuevo.vue';
import EditarDeduccion from '@/components/administracion/configuracion/catalogos/deducciones/Editar.vue';
import EliminarDeduccion from '@/components/administracion/configuracion/catalogos/deducciones/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'DeduccionesDefault',
  components: {
    TituloToolBar,
    RegistrarNuevaDeduccion,
    EditarDeduccion,
    EliminarDeduccion,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaDeduccion: false,
      mostrarVentanaEditarDeduccion: false,
      mostrarVentanaEliminarDeduccion: false,
      estaDeduccion: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    deducciones: {
      query: DEDUCCIONES,
    },
  },
  mounted() {
    eventBus.$on('editar-deduccion', (deduccion) => {
      this.estaDeduccion = deduccion;
      this.mostrarVentanaEditarDeduccion = true;
    });
    eventBus.$on('eliminar-deduccion', (deduccion) => {
      this.estaDeduccion = deduccion;
      this.mostrarVentanaEliminarDeduccion = true;
    });
  },
  methods: {
    registrarNuevaDeduccion() {
      this.mostrarVentanaRegistrarNuevaDeduccion = true;
    },
    cerrarRegistrarNuevaDeduccion() {
      this.mostrarVentanaRegistrarNuevaDeduccion = false;
    },
    cerrarEditarDeduccion() {
      this.mostrarVentanaEditarDeduccion = false;
      this.estaDeduccion = null;
    },
    cerrarRemoverDeduccion() {
      this.mostrarVentanaEliminarDeduccion = false;
      this.estaDeduccion = null;
    },
  },
  computed: {
    getDeducciones() {
      if (!this.deducciones) return [];
      return this.deducciones
      // Filtrar por Texto de Busqueda
        .filter((deduccion) => {
          if (!this.filtros.buscarTexto) return deduccion;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(deduccion.nombre);
          return (
            expt.test(nombre)
            || expt.test(deduccion.nombre)
            || expt.test(deduccion.porcentaje)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
